// extracted by mini-css-extract-plugin
export default {"Backdrop":"Modal_Backdrop__7zwOB","ModalWrapper":"Modal_ModalWrapper__AkRVW","Body":"Modal_Body__0hT+M","Title":"Modal_Title__WhVzv","ModalHeader":"Modal_ModalHeader__Ef+KV"};